import moment from "moment";
import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class LeveransplanCommandBase extends BasicCommand<LeveransplanCommandBase> {
    readonly virkeskostnadGuid: string;
    readonly period: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Leveransplan";

    get primaryKey(): ILeveransplanPrimaryKey {
        return {
            virkeskostnadGuid: this.virkeskostnadGuid,
            period: this.period
        };
    }

    constructor(virkeskostnadGuid: string, period: Date, typeName: string, commandType: CommandType) {
        super(typeName, LeveransplanCommandBase.$groupKey, commandType);
        this.period = moment(period).format("YYYY-MM-DD");
        this.virkeskostnadGuid = virkeskostnadGuid;
    }
}

export interface ILeveransplanPrimaryKey extends  IPrimaryKey<LeveransplanCommandBase>{
    virkeskostnadGuid: string;
    period: string;
}
